import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";
import FormBasicInfoInput from "../formBasicInfo/formBasicInfoInput";
import "./modalFavoirte.css";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import starFavorite from "../../assets/svgs/star.svg";
import closeModal from "../../assets/svgs/close.svg";
import ContainerError from "../error/containerError";
import IconAlert from "../../assets/svgs/icon-alert.svg";
import {
  getFavorite,
  getsessionFavoritePost,
} from "../../redux/actions/fluxoNSimilar";
interface ModalFavoriteProps {
  onClose: () => void;
  productCode?: string;
  setIsModalOpen: any;
  setGetStatusFavorite: any;
  setPnSimilar: any;
  setFilterSearch: any;
  setGetSessionId: any;
  center?: string;
}

const ModalFavorite = ({
  onClose,
  productCode,
  setIsModalOpen,
  setGetStatusFavorite,
  setPnSimilar,
  setFilterSearch,
  setGetSessionId,
  center, 
}: ModalFavoriteProps) => {
  const [displaynickname, setDisplaynickname] = useState("");
  const [pnSimilarError, setPnSimilarError] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const MAX_LENGTH = 50;

  const handleNickNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value.trim() === "") {
      setPnSimilarError("");
    } else if (value.length === MAX_LENGTH) {
      setPnSimilarError("Limite de 50 caracteres atingido.");
    } else {
      setPnSimilarError("");
    }

    setDisplaynickname(value);
  };

  const handleConfirm = async () => {
    const result = await dispatch(
      getsessionFavoritePost({
        productCode: productCode,
        nickname: displaynickname,
        ...(center && { center }),
      })
    );

    if (getsessionFavoritePost.fulfilled.match(result)) {
      setGetSessionId(result?.payload.message);
    } else {
      console.error("Erro ao buscar classificação", result);
    }

    await dispatch(getFavorite());
    setIsModalOpen(false);
    setGetStatusFavorite("unfavorite");
    setPnSimilar(displaynickname);
    setFilterSearch([]);
  };

  return (
    <div className="modalOverlayFavorite">
      <span className="modalContentFavorite">
        <div className="headerModalFavorite">
          <img
            src={starFavorite}
            alt="Icone de estrela de favorito com modal aberto"
            style={{ marginRight: "6.5px" }}
          />

          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar Modal"
            className="closeButton"
          >
            <img
              src={closeModal}
              alt="Fechar Modal"
              style={{ width: "30px"}}
            />
          </button>
        </div>

        <div className="bodyModalFavorite">
          <p className="titleModalFavorite">Dê um nome ao seu favorito</p>

          <div style={{ position: "relative" }}>
            <FormBasicInfoInput
              id="name-for-partnumber"
              label="Nomear*"
              aria-required="true"
              aria-describedby="Nome"
              value={displaynickname}
              onChange={handleNickNameChange}
              maxLength={50}
            />

            {pnSimilarError && (
              <ContainerError
                id="part-number-similar-error"
                label={pnSimilarError}
                icon={IconAlert}
                widthError={"314px"}
                backgroudError={"#D1E4FF"}
                colorError={"#000000"}
              />
            )}
          </div>

          <ButtonGeneric
            title="Confirmar"
            style="buttonGeneric buttonFavorite"
            onClick={handleConfirm}
            colorTitle="#FFFFFF"
            background={"#007BC0"}
            disabled={!displaynickname}
          />
        </div>
      </span>
    </div>
  );
};

export default ModalFavorite;
